import Modal from 'react-modal';
import * as styles from './styles';
import { translate } from 'react-i18next';

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(58, 61, 77, 0.5)',
    zIndex: 10
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '15px 15px 15px 30px',
    width: '80%',
    maxWidth: '27em'
  }
};

export default translate()(({ isOpen, closeModal, logout, i18n }) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={closeModal}
    style={customStyles}
    contentLabel="Example Modal"
  >
    <styles.ModalCloseIcon onClick={closeModal} />
    <styles.ModalTitle>{i18n.t('log_out')}</styles.ModalTitle>
    <styles.ModalText>{i18n.t('log_out_confirm_text')}</styles.ModalText>
    <styles.ModalLine />
    <div style={{ position: 'relative', textAlign: 'right' }}>
      <styles.ModalCancel onClick={closeModal}>{i18n.t('cancel')}</styles.ModalCancel>
      <styles.ModalButtonLogin onClick={logout}>{i18n.t('log_out')}</styles.ModalButtonLogin>
    </div>
  </Modal>
));
